import { useState } from "react";
import PublicNav from "../Components/PublicNav";
import Footer from "../Components/Footer";

function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  function handle(e) {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  }

  function submit(e) {
    e.preventDefault();
    setSent(true);
  }

  return (
    <div className="lp-page">
      <PublicNav />

      <section className="ip-hero">
        <div className="ip-hero-inner">
          <div className="lp-section-label">Contact</div>
          <h1 className="ip-hero-title">Get in touch</h1>
          <p className="ip-hero-sub">
            Have a question, feedback, or need help? We typically respond within 24 hours.
          </p>
        </div>
      </section>

      <section className="ip-section">
        <div className="ip-section-inner ip-contact-layout">
          <div className="ip-contact-info">
            <h2 className="ip-section-title">Contact details</h2>
            <div className="ip-contact-item">
              <div className="ip-contact-label">General support</div>
              <a className="ip-link" href="mailto:rirareview@gmail.com">rirareview@gmail.com</a>
            </div>
            <div className="ip-contact-item">
              <div className="ip-contact-label">Billing</div>
              <a className="ip-link" href="mailto:rirareview@gmail.com">rirareview@gmail.com</a>
            </div>
            <div className="ip-contact-item">
              <div className="ip-contact-label">Response time</div>
              <div className="ip-contact-value">Within 24 hours, Monday – Friday</div>
            </div>
          </div>

          <div className="ip-contact-form-wrap">
            {sent ? (
              <div className="ip-sent">
                <div className="ip-sent-title">Message sent</div>
                <div className="ip-sent-sub">
                  Thank you for reaching out. We will get back to you shortly.
                </div>
              </div>
            ) : (
              <form className="ip-form" onSubmit={submit}>
                <div className="ip-field">
                  <label className="ip-label">Name</label>
                  <input
                    className="ip-input"
                    name="name"
                    value={form.name}
                    onChange={handle}
                    required
                    placeholder="Your name"
                  />
                </div>
                <div className="ip-field">
                  <label className="ip-label">Email</label>
                  <input
                    className="ip-input"
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handle}
                    required
                    placeholder="you@example.com"
                  />
                </div>
                <div className="ip-field">
                  <label className="ip-label">Subject</label>
                  <input
                    className="ip-input"
                    name="subject"
                    value={form.subject}
                    onChange={handle}
                    required
                    placeholder="How can we help?"
                  />
                </div>
                <div className="ip-field">
                  <label className="ip-label">Message</label>
                  <textarea
                    className="ip-textarea"
                    name="message"
                    value={form.message}
                    onChange={handle}
                    required
                    rows={5}
                    placeholder="Tell us more..."
                  />
                </div>
                <button className="ip-submit" type="submit">
                  Send message
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ContactPage;
